import { Box, Button } from '@mui/material'
import { getPxAsRem } from 'shared/utils'
import LoadingSpinner from '../Calendly/components/LoadingSpinner/LoadingSpinner'

interface DrawerCancelSaveProps {
    isSaveDisabled: boolean
    isCancelDisabled?: boolean
    isEditMode: boolean
    isLoading?: boolean
    handleCancel: () => void
    handleSave: () => void
    saveButtonText?: string // "Save" by default
}

const DrawerCancelSave: React.FC<DrawerCancelSaveProps> = ({
    isSaveDisabled,
    isCancelDisabled = false,
    isLoading = false,
    isEditMode,
    handleCancel,
    handleSave,
    saveButtonText = 'Save',
}: DrawerCancelSaveProps) => {
    return (
        <Box sx={{ display: 'flex', gap: getPxAsRem(12) }}>
            <Button
                sx={{ width: '50%' }}
                variant="outlined"
                onClick={handleCancel}
                disabled={isCancelDisabled}
            >
                Cancel
            </Button>
            <Button
                sx={{ width: '50%' }}
                disabled={isSaveDisabled}
                onClick={handleSave}
            >
                {isLoading ? (
                    <LoadingSpinner />
                ) : isEditMode || !saveButtonText ? (
                    'Save'
                ) : (
                    saveButtonText
                )}
            </Button>
        </Box>
    )
}

export default DrawerCancelSave
